/**
 * railTitle.tsx
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled rail title.
 */
const RailTitle = styled.div<React.CSSProperties>`
  align-items: center;
  color: ${Colors['text']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  height: ${42 * Screen.widthRatio}px;
  padding-bottom: ${16 * Screen.widthRatio}px;
  width: ${1920 * Screen.widthRatio}px;
`;

export default RailTitle;
